import { Row, Col } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";

const CVProfileBio = ({ cvdata }) => {
  return (
    <Row>
      <Col md={8} lg={7} xl={6}>
        {/* Header */}
        <div className="name-back py-4 mt-5">
          <h5 className="text-white fs-2 fw-bold mb-0 ps-3">
            {cvdata?.profileInformation?.firstName}
          </h5>
          <h6 className="text-white fs-5 ps-3">
            {cvdata?.profileInformation?.jobDesignation}
          </h6>
        </div>

        {/* Scrollable Body */}
        <div className="profile-bio-scroll-3">
          {/* Previous Employment */}
          <div>
            <h6 className="text-color-cv3">Previous Employment Details</h6>
            {cvdata?.preemphistory?.map((item, index) => (
              <Row key={index} className="mb-3">
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Company Name</p>
                    <p className="text-designation-color">{item?.companyname}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Start Date</p>
                    <p className="text-designation-color">{item?.startdate}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Industry</p>
                    <p className="text-designation-color">{item?.industry}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Designation</p>
                    <p className="text-designation-color">{item?.designation}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">End Date</p>
                    <p className="text-designation-color">{item?.enddate}</p>
                  </div>
                </Col>
              </Row>
            ))}
            <hr />
          </div>

          {/* Formal Education */}
          <div>
            <h6 className="text-color-cv3">Formal Education</h6>
            {cvdata?.formaleducation?.map((item, index) => (
              <Row key={index} className="mb-3">
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Institute Name</p>
                    <p className="text-designation-color">
                      {item?.institutename}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Qualification</p>
                    <p className="text-designation-color">
                      {item?.qualification}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Start Date</p>
                    <p className="text-designation-color">{item?.startdate}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Degree Status</p>
                    <p className="text-designation-color">
                      {item?.degreestatus}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Major</p>
                    <p className="text-designation-color">{item?.major}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Type of Study</p>
                    <p className="text-designation-color">
                      {item?.typeofstudy}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">End Date</p>
                    <p className="text-designation-color">{item?.enddate}</p>
                  </div>
                </Col>
              </Row>
            ))}
            <hr />
          </div>

          {/* Professional Skills */}
          <div>
            <h6 className="text-color-cv3">Professional Skills</h6>
            <Row>
              <Col md={12}>
                {cvdata?.profesionalskils?.map((item, index) => (
                  <div key={index}>
                    <p className="text-designation-color">{item}</p>
                  </div>
                ))}
              </Col>
            </Row>
            <hr />
          </div>

          {/* Language Skills */}
          <div>
            <h6 className="text-color-cv3">Language Skills</h6>
            {cvdata?.languageskils?.map((item, index) => (
              <Row key={index} className="mb-3">
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Language</p>
                    <p className="text-designation-color">{item?.language}</p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Reading Proficiency</p>
                    <p className="text-designation-color">
                      {item?.readingproficiency}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Speaking Proficiency</p>
                    <p className="text-designation-color">
                      {item?.speakingproficiency || item?.speekingproficiency}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Writing Proficiency</p>
                    <p className="text-designation-color">
                      {item?.writingproficiency}
                    </p>
                  </div>
                </Col>
              </Row>
            ))}
            <hr />
          </div>

          {/* Certifications / Licences */}
          <div>
            <h6 className="text-color-cv3">Certifications / Licences</h6>
            {cvdata?.certification?.map((item, index) => (
              <Row key={index} className="mb-3">
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Name of Certification</p>
                    <p className="text-designation-color">
                      {item?.nameofcertificate}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Issuing Authority</p>
                    <p className="text-designation-color">
                      {item?.issuingauthority}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Expiring Date</p>
                    <p className="text-designation-color">
                      {item?.expirationdate}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div>
                    <p className="updateSize mb-0">Institution</p>
                    <p className="text-designation-color">
                      {item?.institution}
                    </p>
                  </div>
                  <div>
                    <p className="updateSize mb-0">Effective Date</p>
                    <p className="text-designation-color">
                      {item?.effectivedate}
                    </p>
                  </div>
                </Col>
              </Row>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default CVProfileBio;
